module.exports = __webpack_public_path__ + "img/icon.10a6b59d.png";